import React, { useEffect } from "react";
import { Product } from "../interfaces/home_entity";
import ProductCard from "../components/ProductCard"
import NoData from "../components/NoData";

interface SearchResultsProps {
  query: string;
  products: Product[];
  onClose: () => void;
}

const SearchResults: React.FC<SearchResultsProps> = ({ query, products, onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  // If search is empty, don't show the modal
  if (!query.trim()) return null;

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="search-modal-overlay" onClick={onClose}>
      <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="search-modal-close" onClick={onClose}>
          &times;
        </button>
        {filtered.length > 0 ? (
          <div className="product-grid">
            {filtered.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <NoData message="No products found." />
        )}
      </div>
    </div>
  );
};

export default SearchResults;
